module.exports = __webpack_public_path__ + "static/media/adskIcon-rosetta-512.c06a2da3.png";